import _sfc_main from "./AIControl.vue2.mjs";
/* empty css                */
import normalizeComponent from "../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _setup.AIControlConfig.visible ? _c("div", { staticClass: "more-control-container" }, [_c(_setup.IconButton, { attrs: { "is-active": _setup.sidebarName === "aiTranscription", "title": _setup.t("AI Assistant"), "icon": _setup.AIIcon }, on: { "click-icon": _setup.toggleToolBox } }), !_setup.isSidebarOpen && _setup.showToolBox ? _c("div", { staticClass: "tool-box" }, [_c("div", { staticClass: "tool-box-item", on: { "click": _setup.openAISubtitles } }, [_c(_setup.SvgIcon, { staticClass: "icon", attrs: { "icon": _setup.AISubtitlesIcon } }), !_setup.showSubtitles ? _c("span", [_vm._v(_vm._s(_setup.t("Turn on AI real-time subtitles")))]) : _c("span", [_vm._v(_vm._s(_setup.t("Turn off AI real-time subtitles")))])], 1), _c("div", { staticClass: "tool-box-item", on: { "click": _setup.toggleAITranscription } }, [_c(_setup.SvgIcon, { staticClass: "icon", attrs: { "icon": _setup.AITranscription } }), _c("span", [_vm._v(_vm._s(_setup.t("Enable AI real-time meeting recording")))])], 1)]) : _vm._e()], 1) : _vm._e();
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "5bc7c4c4"
);
const AIControl = __component__.exports;
export {
  AIControl as default
};
